// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"151":"9c68d478","180":"49afc7f6","376":"7ec73bc6","459":"9eb3e7cb","561":"fc34b288","798":"3e3eddea","810":"46fb9dc7","893":"536005f5"}[chunkId] + ".css";
};